/**
 * Emotional states — the nervous-system states the user can select.
 * Each maps to primary/secondary breathing protocols.
 * Ported from the standalone Calm The Body app (states.js).
 */

export interface State {
  id: string;
  label: string;
  description: string;
  icon: string;
  primaryProtocolIds: string[];
  secondaryProtocolIds: string[];
}

export const STATES: State[] = [
  {
    id: 'panic',
    label: 'Panic / acute anxiety',
    description: "My body feels like it's spiking",
    icon: '⚡',
    primaryProtocolIds: ['panic_reset', 'extended_exhale'],
    secondaryProtocolIds: ['extended_exhale'],
  },
  {
    id: 'overwhelm',
    label: 'Overwhelm / flooded',
    description: 'Too much, too fast',
    icon: '🌊',
    primaryProtocolIds: ['find_the_ground'],
    secondaryProtocolIds: [],
  },
  {
    id: 'edgy',
    label: 'Edgy / wired',
    description: "I can't settle",
    icon: '⚙️',
    primaryProtocolIds: ['long_let_go'],
    secondaryProtocolIds: [],
  },
  {
    id: 'rumination',
    label: 'Rumination / looping thoughts',
    description: "My mind won't stop",
    icon: '🔄',
    primaryProtocolIds: ['loop_breaker'],
    secondaryProtocolIds: [],
  },
  {
    id: 'cant_sleep',
    label: "Can't sleep",
    description: "I'm tired but still activated",
    icon: '🌙',
    primaryProtocolIds: ['sleep_descent'],
    secondaryProtocolIds: [],
  },
  {
    id: 'dissociated',
    label: 'Dissociated / numb',
    description: 'I feel far away or shut off',
    icon: '🫧',
    primaryProtocolIds: ['come_back'],
    secondaryProtocolIds: [],
  },
  {
    id: 'flat',
    label: 'Flat / low energy',
    description: 'Nothing is there — empty, depleted',
    icon: '🪨',
    primaryProtocolIds: ['voo_breath'],
    secondaryProtocolIds: [],
  },
  {
    id: 'relax',
    label: 'Relax',
    description: 'Slow, even rhythm to settle',
    icon: '⚗️',
    primaryProtocolIds: ['relax_box'],
    secondaryProtocolIds: [],
  },
];

export const STATE_MAP: Record<string, State> = Object.fromEntries(
  STATES.map((s) => [s.id, s]),
);

/** Look up a state by id. */
export function getState(id: string): State | undefined {
  return STATE_MAP[id];
}
